// Dependecies
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import Alert from 'react-bootstrap/Alert';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { Pagination } from 'antd';

// Components
import Template from '../../components/Template';
import Reload from '../../components/Reload';
import FixedJobRequest from '../../components/JobRequest';

// Images
import edit from '../../../sass/images/workshop/icon-feather-edit.svg';
import check from '../../../sass/images/icons/check.svg';
import infoAlert from '../../../sass/images/alert/info-alert.svg';
import successAlert from '../../../sass/images/alert/icon-check-alert.svg';
import errorAlert from '../../../sass/images/alert/icon-error-alert.svg';
import notPlan from '../../../sass/images/company/not-plan.svg';
import alert from '../../../sass/images/alert/alert.svg';
import search from '../../../sass/images/icons/search.svg';

// Hooks
import useCompany from '../../hooks/useCompany';
import useNotificationRead from '../../hooks/useNotificationRead';
// Utils
import { contactEmail } from '../../helpers';

function Dashboard(props) {
  const { newMaintenancesCompany } = useNotificationRead();
  const { t } = props;
  const [activeKey, setActiveKey] = useState(0);
  const {
    reload,
    alertUpdate,
    messageError,
    submit,
    submitPhone,
    company,
    address,
    setAddress,
    editAddress,
    phone,
    setPhone,
    editPhone,
    vehicles,
    number,
  } = useCompany();

  const [currentPage, setCurrentPage] = useState(1);
  const [minIndex, setMinIndex] = useState(0);
  const [maxIndex, setMaxIndex] = useState(5);
  const [cardPerPage] = useState(5);

  // change page
  const handleChange = (page) => {
    setCurrentPage(page);
    setMinIndex((page - 1) * cardPerPage);
    setMaxIndex(page * cardPerPage);
  };

  const { register, handleSubmit, errors } = useForm();
  const [searchTerm, setSearchTerm] = useState('');

  // handle input change
  const handleInputChange = (e, set) => {
    const { value } = e.target;
    set(value);
  };
  return (
    <Template
      type={4}
      newMaintenances={newMaintenancesCompany}
      classNameContainer="dashboardCompany"
      className="container_menu dashboardCompany"
    >
      {!reload ? (
        <Reload
          number={-1}
          title={t('title-profile')}
          text={t('alert:reload')}
          img={notPlan}
          firstTxt={t('alert:first-txt')}
          secondTxt={t('alert:second-txt')}
          link={t('routers:PlansCompany')}
          linkTxt={t('alert:link-txt')}
        />
      ) : (
        <>
          <FixedJobRequest />
          <div className="content_dynamic history dashboardCompany perfil_company">
            <Row className="content_maintenace">
              <div className="header-content">
                <div className="info-tittle">
                  <h1>{t('title-profile')}</h1>
                  <p className="txt-16">{t('description-profile')}</p>
                </div>
              </div>
            </Row>
            <div className="perfil">
              <div className="row no-gutters">
                <div className="col-md-4 col-sm-12 information-head">
                  <label htmlFor="name" className="col-form-label">
                    {t('name-workshop')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="name"
                    readOnly
                    defaultValue={company ? company.name : t('value-null')}
                  />
                </div>
                <div className="col-md-4 col-sm-12 information-head">
                  <label htmlFor="rut" className="col-form-label">
                    {t('rut-workshop')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="rut"
                    readOnly
                    defaultValue={company ? company.rut : t('value-null')}
                  />
                </div>
                <div className="col-md-4 col-sm-12 information-head">
                  <label htmlFor="email" className="col-form-label">
                    {t('email')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="email"
                    readOnly
                    defaultValue={company ? company.email : t('value-null')}
                  />
                </div>
              </div>
              <div className="row no-gutters">
                <div className="col-md-4 col-sm-12 information-head">
                  <label htmlFor="country" className="col-form-label">
                    {t('country')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="country"
                    readOnly
                    defaultValue={company ? company.contry : t('value-null')}
                  />
                </div>
                <div className="col-md-4 col-sm-12 information-head">
                  <label htmlFor="city" className="col-form-label">
                    {t('city')}
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    id="city"
                    readOnly
                    defaultValue={company ? company.city : t('value-null')}
                  />
                </div>
              </div>
              <div className="row no-gutters">
                <div className="col-md-4 col-sm-12 information-head">
                  <form onSubmit={handleSubmit((data) => submit(data, company.id))}>
                    <div className="row">
                      <div className="col aling-text">
                        <label htmlFor="address" className="col-form-label">
                          {t('address')}
                        </label>
                        <input
                          className={`form-control ${!editAddress ? 'disabled-input' : ''}`}
                          id="address"
                          name="address"
                          type="text"
                          value={address || t('value-null')}
                          onChange={(e) => handleInputChange(e, setAddress)}
                          ref={register({
                            required: true,
                          })}
                          disabled={!!editAddress}
                          defaultValue={address || t('value-null')}
                        />
                        {errors.address && (
                          <div className="error_input">
                            <p>
                              <img src={alert} alt={t('alt:notification')} />
                              {t('alert:required-field')}
                            </p>
                          </div>
                        )}
                        <button type="submit" className="edit-icon-company">
                          <img src={editAddress ? edit : check} alt={t('alt:edit_information')} />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div className="col-md-4 col-sm-12 information-head">
                  <form onSubmit={handleSubmit((data) => submitPhone(data, company.id))}>
                    <div className="row">
                      <div className="col aling-text">
                        <label htmlFor="phone" className="col-form-label">
                          {t('phone')}
                        </label>
                        <input
                          className={`form-control ${!editPhone ? 'disabled-input' : ''}`}
                          id="phone"
                          name="phone"
                          maxLength="11"
                          type="text"
                          value={!phone ? 0 : phone}
                          onChange={(e) => handleInputChange(e, setPhone)}
                          ref={register({
                            required: {
                              value: true,
                              message: t('alert:required-field'),
                            },
                            pattern: {
                              value: /[0-9]$/,
                              message: t('alert:number'),
                            },
                          })}
                          disabled={!!editPhone}
                          defaultValue={!phone ? 0 : phone}
                        />
                        <button type="submit" className="edit-icon-company">
                          <img src={editPhone ? edit : check} alt={t('alt:edit_information')} />
                        </button>
                      </div>
                    </div>
                    {errors.phone && (
                      <div className="error_input">
                        <p>
                          <img src={alert} alt={t('alt:notification')} />
                          {errors.phone.message}
                        </p>
                      </div>
                    )}
                  </form>
                </div>
              </div>
            </div>

            <Row className="no-gutters">
              <div className="col-sm-12">
                <Alert variant="warning">
                  <Alert.Heading>
                    <img src={infoAlert} alt={t('alt:notification')} />
                  </Alert.Heading>
                  <p className="alert-profile-company">
                    {t('alert:info-contact3')}
                    <strong> {contactEmail()}. </strong>
                  </p>
                </Alert>
              </div>
            </Row>

            <Row className="no-gutters">
              <div className="col-md-12 filter-vehicles">
                <label htmlFor="name" className="col-form-label">
                  {t('search')} :
                </label>
                <input
                  className="form-control"
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  type="text"
                />
                <img src={search} alt={t('alt:search')} />
              </div>
              <div className="col-md-12">
                <h3 className="txt-20">
                  {t('vehicle-num')} {number}
                </h3>
                {vehicles
                  .filter(
                    (res) =>
                      res.licenseplate.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      res.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      res.model.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      res.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
                      res.vehiclePackage.km_start.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map(
                    (vehicle, index) =>
                      index >= minIndex &&
                      index < maxIndex && (
                        <Container
                          key={vehicle.id}
                          className={`main-card card-maintenances vehicle block-${
                            activeKey === vehicle.id ? 'show' : 'hidden'
                          }`}
                          onClick={() => {
                            if (activeKey === vehicle.id) {
                              setActiveKey(null);
                            } else {
                              setActiveKey(vehicle.id);
                            }
                          }}
                        >
                          <div className="borde-status-profile status-6-none" />
                          <Row className="no-gutters">
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('plate')}</p>
                              <p className="title2-vehicle">{vehicle.licenseplate}</p>
                            </Col>
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('brand')}</p>
                              <p className="title2-vehicle">{vehicle.brand}</p>
                            </Col>
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('model')}</p>
                              <p className="title2-vehicle">{vehicle.model}</p>
                            </Col>
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('city-vehicle')}</p>
                              <p className="title2-vehicle">{vehicle.city}</p>
                            </Col>
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('start-km')}</p>
                              <p className="title2-vehicle">
                                {vehicle.vehiclePackage ? vehicle.vehiclePackage.km_start : 0}
                              </p>
                            </Col>
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('date-start-plan')}</p>
                              <p className="title2-vehicle">
                                {vehicle.vehiclePackage ? (
                                  <Moment format="DD/MM/YYYY">
                                    {vehicle.vehiclePackage.created_at}
                                  </Moment>
                                ) : (
                                  <>-- / -- / --</>
                                )}
                              </p>
                            </Col> 
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={4} lg="auto">
                              <p className="title-vehicle">{t('last-service')}</p>
                              <p className="title2-vehicle">
                                {vehicle.last_mantenaice ? (
                                  <Moment format="DD/MM/YYYY">{vehicle.last_mantenaice}</Moment>
                                ) : (
                                  <>-- / -- / --</>
                                )}
                              </p>
                            </Col>
                            <Col className="block-vehicle-txt" xs={6} sm="auto" md={3} lg="auto">
                              <p className="title-vehicle">{t('status')}</p>
                              {vehicle.status === 'maintenance required' ? (
                                <p className="title2-vehicle color-red">{vehicle.status}</p>
                              ) : (
                                <p className="title2-vehicle">{vehicle.status}</p>
                              )}
                            </Col>
                          </Row>
                        </Container>
                      )
                  )}
              </div>

              <Pagination
                className="col-12"
                size="small"
                defaultCurrent={1}
                total={vehicles.length}
                defaultPageSize={cardPerPage}
                current={currentPage}
                onChange={handleChange}
              />
            </Row>

            {alertUpdate && (
              <Alert variant="success" className="alert-response">
                <img src={successAlert} alt={t('alt:successAlert')} /> &nbsp;&nbsp;{' '}
                <p>{t('alert:success')}</p>
              </Alert>
            )}
            {messageError && (
              <Alert variant="danger" className="alert-response">
                <img src={errorAlert} alt={t('alt:errorAlert')} />
                <p>{t('alert:error')}</p>
              </Alert>
            )}
          </div>
        </>
      )}
    </Template>
  );
}

Dashboard.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation(['profileCompany', 'alert', 'alt', 'routers'])(Dashboard);
